"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainGridAppIdFetchSymbol = exports.SsrPlatformConfigSym = void 0;
exports.SsrPlatformConfigSym = Symbol('SsrPlatformConfigSym');
exports.MainGridAppIdFetchSymbol = Symbol('MainGridAppIdFetch');
//# sourceMappingURL=platformConfig.js.map